// extracted by mini-css-extract-plugin
export default {"spendingDate":"addSpending_spendingDate__QuSNt"};